const binding = { modules: {}, dataActions: {} };

    (binding.modules['returns'] = {
        c: () => require('partner/modules/returns/returns.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'returns',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/returns'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|returns|returns'] = {
                c: () => require('partner/modules/returns/returns.view.tsx'),
                cn: '__local__-__local__-returns'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };